import { useQuery } from "@tanstack/react-query";
import { get } from "utils/request";
import { useEffect, useState } from "react";
import { getExclusiveMembersRoute } from "utils/helpers";
import { useDataProviderContext } from "../../DataProvider";
import ExclusiveMembersComponent from "./ExclusiveMembersComponent";

function ExclusiveMembersContainer() {
  const { magnetDetailsState } = useDataProviderContext();
  const [memebersArray, setMembersArray] = useState<ExclusiveMembers>([]);
  const [listRerenderCount, setListRerenderCount] = useState(0);

  const fetchExclusiveMembersList = () =>
    get(getExclusiveMembersRoute(magnetDetailsState?.brand_id as string, magnetDetailsState?.id as string), {
      processError: (errorMessage: any) => {
        throw Error(errorMessage);
      },
    });

  // Get available activations for magnet.
  const {
    error: fetchMembersListError,
    data,
    isLoading: isMemebersListLoading,
    refetch: refetchMembersData,
  } = useQuery({
    queryKey: ["exclusive-members-list", magnetDetailsState?.id],
    queryFn: fetchExclusiveMembersList,
    enabled: !!magnetDetailsState?.id && magnetDetailsState.type === 1,
  });

  useEffect(() => {
    if (data && data.members) {
      const membersArr = Object.keys(data.members).map((email: string) => ({ email, status: data.members[email] }));
      membersArr.sort((a, b) => a.email.localeCompare(b.email));
      setMembersArray(membersArr);
      setListRerenderCount(listRerenderCount + 1);
    }
  }, [JSON.stringify(data)]);

  if (isMemebersListLoading) {
    return <div>Loading...</div>;
  }
  if (fetchMembersListError) {
    return <div>Oops, something went wrong. Please try again later.</div>;
  }

  if (memebersArray.length) {
    return (
      <ExclusiveMembersComponent
        membersList={memebersArray}
        refetchMembersData={refetchMembersData}
        key={listRerenderCount}
      />
    );
  }

  return null;
}

export default ExclusiveMembersContainer;
